// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__XSBuU","danger":"Alert_danger__zIdRg","success":"Alert_success__rm83o"};